function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  fill: "currentColor",
  cx: 24,
  cy: 24,
  r: 3
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 11,
  cy: 24,
  r: 3
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 32,
  cy: 14,
  r: 4.5
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 33,
  cy: 27,
  r: 3
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 16,
  cy: 33,
  r: 3.75
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 20,
  cy: 16,
  r: 3
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 27,
  cy: 36,
  r: 1.688
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "currentColor",
  cx: 12.125,
  cy: 13,
  r: 1.688
});

var SvgAcne = function SvgAcne(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcne, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acne.56aa26df.svg";
export { ForwardRef as ReactComponent };